export default __webpack_public_path__ + "static/media/concourse.6cf6901c.svg";